module.exports = __webpack_public_path__ + "img/pic-DonTang.38db9c8f.png";